import { Deserializable } from '../deserializable';
import { MediaInfo } from '../general/media-info';

export class UserFiaPins implements Deserializable {
  public id: number;
  public pin: string;
  public pinIssueDate: Date;
  public pinExpiryDate: Date;
  public fiaApplicationId: number;
  public userId: number;
  public pinAmount: number;
  public pinBalance: number;
  public transactionUsedAmount: number;
  public pinMedia: MediaInfo;
  public reservedAmount: number;
  public comment: string;
  public edit: boolean;
  public manuallyEnteredReferenceNumber: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  static calculatePinAvailableAmount(userFiaPins: UserFiaPins[]) {
    var totalPinAvailableAmount: number = 0;
    if (userFiaPins == null) {
      return totalPinAvailableAmount;
    }

    if (userFiaPins.length === 0) {
      return totalPinAvailableAmount;
    }

    userFiaPins.forEach((pin) => {
      if (pin.pinBalance <= 0) {
        return;
      }

      if (this.hasPinExpired(pin)) {
        return;
      }
      totalPinAvailableAmount += pin.pinBalance;
    });

    return totalPinAvailableAmount;
  }

  public static hasPinExpired(pin: UserFiaPins): boolean {
    const now = new Date();
    const expiry = new Date(pin.pinExpiryDate);
    if (now > expiry) {
      return true;
    }
    return false;
  }
}
